import { omit } from "../../utils/lodash";
import { ValidationResultModel } from "../ValidationResultModel";
import { isNullOrEmpty } from "../../utils";

export class ValidationBuilder {
    private result: ValidationResultModel;

    /**
     * Creates a validation result builder, defaulting with a valid result without errors.
     */
    constructor(result?: ValidationResultModel) {
        this.result = result || { isValid: true, errorsByVariableName: {} };
    }

    /**
     * Returns the validation result.
     */
    build(): ValidationResultModel {
        return this.result;
    }

    /**
     * Sets validity of the result.
     */
    setValid(isValid: boolean) {
        this.result = { ...this.result, isValid };
        return this;
    }

    /**
     * Fails validation and adds an error.
     * @param variableName
     * @param key
     * @param args
     */
    fail(
        variableName?: string,
        key?: string,
        args?: { [name: string]: string },
        message?: string,
    ): ValidationBuilder {
        if (isNullOrEmpty(variableName) || isNullOrEmpty(key)) {
            return this.setValid(false);
        }
        this.result = {
            ...this.result,
            isValid: false,
            errorsByVariableName: {
                ...this.result.errorsByVariableName,
                [variableName]: [...this.getErrors(variableName), { key, args, message }],
            },
        };
        return this;
    }

    /**
     * Gets all errors for a given variable.
     * @param variableName
     */
    getErrors(variableName: string) {
        return this.result.errorsByVariableName[variableName] || [];
    }

    /**
     * Clears an error or all errors if variableName is not specified.
     * @param variableName
     */
    clear(variableName?: string) {
        this.result = {
            ...this.result,
            errorsByVariableName: omit(this.result.errorsByVariableName, variableName) as {},
        };
        return this;
    }
}
